import tinymce from 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/link';
import 'tinymce/plugins/save';
import 'tinymce/plugins/paste';
import 'tinymce-i18n/langs5/ja';
export { tinymce };
